<template>
  <div class="ly_modal_container" :style="{width: '840px', height: '585px',zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">{{getNewsTypeText(newsType)}} 전송이력</h1>
    </div>
    <div class="ly_modal_content" style="min-height:537px">
      <ul class="section_tab">
        <li class="cell">
          <button
            type="button"
            class="item router-link-exact-active"
            :class="{'selected' : logType === 'daily'}"
            @click="logType = 'daily'"
          >Daily 전송이력</button>
        </li>
        <li class="cell">
          <button
            type="button"
            class="item router-link-exact-active"
            :class="{'selected' : logType === 'itemBy'}"
            @click="logType = 'itemBy'"
          >건별전송이력</button>
        </li>
      </ul>
      <template v-if="detailData">
        <div class="section_textarea">
          소식 종류 :
          <span
            v-if="newsType === 'CUSTOM'"
            class="highlight"
          >맞춤소식[{{getCustomNewsText(customNewsType)}}]</span>
          <span v-else class="highlight">반복소식</span>
          <template v-if="logType === 'daily'">
            <span class="tab">|</span>최초 전송날짜 :
            <span class="highlight">{{$utils.dateText(detailData.firstSendDate)}}</span>
          </template>
          <template v-else-if="logType === 'itemBy'">
            <span class="tab">|</span>최초 전송시간 :
            <span class="highlight">{{$utils.timeText(detailData.firstSendDate)}}</span>
          </template>
          
        </div>
        <component :is="tableComp" :detailData="detailData" @viewRcp="onClickRcpView" />
      </template>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import newsMixin from "$views/News/_mixin";
import popupMixin from "$mixins/popup";

import DailyTable from "./RepeatSendLogs.table.daily";
import ItemByTable from "./RepeatSendLogs.table.itemBy";

export default {
  mixins: [popupMixin, newsMixin],
  components: {
    DailyTable,
    ItemByTable
  },
  props: {
    newsId: [String, Number],
    newsType: String,
    customNewsType: String
  },
  data() {
    return {
      logType: "itemBy",
      detailData: null
    };
  },
  watch: {
    logType() {
      this.loadData();
    }
  },
  computed: {
    tableComp() {
      return this.logType === "itemBy" ? "ItemByTable" : "DailyTable";
    }
  },
  methods: {
    onClickRcpView(sendDate) {
      const props = {
        newsId: this.newsId,
        newsType: this.newsType,
        sendDate,
        logType: this.logType
      };
      this.openRepeatSendLogsRcpList(props);
    },
    loadData() {
      this.detailData = null;
      this.$axios
        .get(`/admin/v2/news/repeat/${this.newsId}/logs/${this.logType}`)
        .then(({ data }) => (this.detailData = data));
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
